import React, { useState } from "react";
import { Card, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { newBrussels } from "../../data/cheapBrussels";
import { newBarcelona600 } from "../../data/newBarcelona600";
import { newBerlin600 } from "../../data/newBerlin600";
import { newLondon800 } from "../../data/newLondon";
import { newRome600 } from "../../data/newRome600";
import { nowParis } from "../../data/nowParis";

import { SetItem } from "../common/GeneratorItem";

export default function Generator() {
  const user = useSelector((state) => state.auth.user);
  //switch to hot cities
  const [hotCities, setHotCities] = useState(newBrussels);
  const [isNoHotCities, setNoHotCities] = useState(true);
  const [isBrussels, setBrussels] = useState(false);
  const [isBerlin, setBerlin] = useState(false);
  const [isParis, setParis] = useState(false);
  const [isBarcelona, setBarcelona] = useState(false);
  const [isRome, setRome] = useState(false);
  const [isLondon, setLondon] = useState(false);



  const switchToBrussels = () => {
    setBrussels(!isBrussels);
    setLondon(false);
    setParis(false);
    setBarcelona(false);
    setRome(false);
    setBerlin(false);
    setNoHotCities(false);
    setHotCities(newBrussels);
  };

  const switchToBerlin = () => {
    setBerlin(!isBerlin);
    setLondon(false);
    setParis(false);
    setBarcelona(false);
    setRome(false);

    setNoHotCities(false);
    setHotCities(newBerlin600);
  };

  const switchToLondon = () => {
    setLondon(!isLondon);
    setBrussels(false);
    setBarcelona(false);
    setRome(false);
    setBerlin(false);
    setNoHotCities(false);
    setHotCities(newLondon800);
  };
  const switchToBarcelona = () => {
    setBarcelona(!isBarcelona);
    setParis(false);
    setBrussels(false);
    setRome(false);
    setBerlin(false);
    setLondon(false);
    setNoHotCities(false);
    setHotCities(newBarcelona600);
  };
  const switchToRome = () => {
    setRome(!isRome);
    setParis(false);
    setBarcelona(false);
    setBrussels(false);
    setBerlin(false);
    setLondon(false);
    setNoHotCities(false);
    setHotCities(newRome600);
  };
  const switchToParis = () => {
    setParis(!isParis);
    setRome(false);
    setBarcelona(false);
    setBrussels(false);
    setBerlin(false);
    setLondon(false);
    setNoHotCities(false);
    setHotCities(nowParis);
  };

  const switchToNoHotCities = () => {
    setNoHotCities(!isNoHotCities);
    setParis(false);
    setBarcelona(false);
    setRome(false);
    setBerlin(false);
    setBrussels(false);
    setHotCities([]);
  };

  function addId() {
    hotCities.forEach((item, i) => {
      item.id = `london${i + 1}`;
    });
    console.log("newLondon", JSON.stringify(hotCities));
  }

  return (
    <>
      {user.role === "admin" && <button onClick={addId}> AddId </button>}
      <div className="card card-info bg-transparent">
        <Card className="bg-info - shadow shadow-info ">
          {/* <Accordion.Toggle as={Button} variant="link" eventKey="0">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignText: "center",
              }}
            >
              <div className="card-header badge badge-medium text-white text-center">
                Switch to Hot Properties
              </div>

              <i className="fa fa-solid fa-sort-down text-white text-right "></i>
            </div>
          </Accordion.Toggle> */}
          <Card.Body>
            <div className="card-body d-flex flex-row flex-wrap ">
              <span
                onClick={() => switchToBrussels()}
                className="badge bg-dark mr-1 text-white border border-2 border-white"
                style={{ cursor: "pointer" }}
              >
                Brussels
              </span>
              <span
                onClick={() => switchToBerlin()}
                className="badge bg-dark mr-1 text-white border border-2 border-white"
                style={{ cursor: "pointer" }}
              >
                Berlin
              </span>
              <span
                onClick={() => switchToRome()}
                className="badge bg-dark mr-1 text-white border border-2 border-white"
                style={{ cursor: "pointer" }}
              >
                Rome
              </span>
              <span
                onClick={() => switchToBarcelona()}
                className="badge bg-dark mr-1 text-white border border-2 border-white"
                style={{ cursor: "pointer" }}
              >
                Barcelona
              </span>
              <span
                onClick={() => switchToParis()}
                className="badge bg-dark mr-1 text-white border border-2 border-white"
                style={{ cursor: "pointer" }}
              >
                Paris
              </span>
              <span
                onClick={() => switchToLondon()}
                className="badge bg-dark mr-1 text-white border border-2 border-white"
                style={{ cursor: "pointer" }}
              >
                London
              </span>

              {/* 
                

                <span
                  onClick={() => switchToNoHotCities()}
                  className="badge bg-dark mr-1 text-white border border-2 border-white"
                  style={{ cursor: "pointer" }}
                >
                  Close
                </span> */}
            </div>
          </Card.Body>
        </Card>
      </div>
      <Row
        xs={2}
        md={10}
        className="container-fluid mt-2 mb-2 text-center"
        style={{ display: "flex", direction: "row", flexWrap: "wrap" }}
      >
        {hotCities.map((item) => (
          <SetItem
            key={item.id}
            id={item.id}
            title={item.title}
            available={item.available}
            rent={item.rent}
            permonth={item.permonth}
            link={item.link}
            image={item.image}
            newBrussels={item.hotCities}
          />
        ))}
      </Row>
    </>
  );
}
